import { Auth0Provider } from '@auth0/auth0-react';

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Auth0Provider
      useRefreshTokens
      cacheLocation="localstorage"
      domain={process.env.REACT_APP_AUTH_DOMAIN}
      clientId={process.env.REACT_APP_AUTH_CLIENT}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: `https://${process.env.REACT_APP_AUTH_DOMAIN}/api/v2/`,
        scope: 'read:current_user update:current_user_metadata offline_access',
      }}
    >
      {children}
    </Auth0Provider>
  );
};
